<template>
  <b-form-group
    label="Stok Kartı"
    label-for="id_stocks"
  >
    <validation-provider
      #default="{ errors }"
      name="Stok Kartı"
      rules="required"
    >
      <v-select
        v-model="dataItem[iKey].id_stocks"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
        @input="changeSelect"
      >
        <template v-slot:option="option">
          <div v-if="option.scode">
            <small class="text-warning">{{ option.scode }}</small>
          </div>
          {{ option.title }} <small class="text-info">({{ option.units }})</small>
          <div v-if="option.stock_groups">
            <small class="text-primary">{{ option.stock_groups }}</small>
          </div>
        </template>
        <template v-slot:selected-option="option">
          <span class="text-warning">{{ option.scode }}</span> - {{ option.title }}
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PurchaseItemStockSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['stocks/dataList']
    },
    dataItem() {
      return this.$store.getters['purchaseOfferItems/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('stocks/getDataList', {
        select: [
          'stocks.id AS id',
          'stocks.title AS title',
          'stocks.scode AS scode',
          'units.title AS units',
          'stock_groups.title AS stock_groups',
        ],
      })
    },
    changeSelect() {
      // dataItem[iKey].units 'a seçilen dataItem[iKey].id_stocks elemanının değerine eşit dataList dizisinin indislerindeki id elemanının değeri ile eşit olan indisin units değerinin atanması.
      const match = this.dataList.find(item => item.id === this.dataItem[this.iKey].id_stocks)
      if (match) {
        this.dataItem[this.iKey].units = match.units
      }
    },
  },
}
</script>
